import { useMemo } from 'react'

import useFarwestEquivalentUnitCount from '../../table/hooks/useFarwestEquivalentUnitCount'
import {
  useFwWingstopR365AverageWeeklySalesbyOrderMode,
  useFwWingstopR365TotalSalesPercentbyOrderMode,
  useFwWingstopR365TotalSalesbyOrderMode,
} from '../../tableV2/hooks/fwWingstop/useR365SalesByOrderMode'

const titleData = {
  farwestFlashSalesByOrderModeWeek1InPast: '',
  farwestFlashSalesByOrderModeWeek2InPast: '',
  farwestFlashSalesByOrderModeWeek3InPast: '',
  farwestFlashSalesByOrderModeWeek4InPast: '',
  farwestFlashSalesByOrderModeWeek5InPast: '',
  farwestFlashSalesByOrderModeWeek6InPast: '',
  farwestFlashSalesByOrderModeWeek7InPast: '',
  farwestFlashSalesByOrderModeWeek8InPast: '',
}

const buildFwWingstopR365SalesByOrderMode = (kpiNames: string[]) => {
  const useFwWingstopR365SalesbyOrderMode = () => {
    const { data: avgSalesbyOrderModeData, loading: salesbyOrderModeLoading } =
      useFwWingstopR365AverageWeeklySalesbyOrderMode()
    const { data: salesbyOrderModeData, loading: salesbyDeliveryModeLoading } =
      useFwWingstopR365TotalSalesbyOrderMode()
    const {
      data: salesPercentbyOrderModeData,
      loading: salesPercentbyOrderModeLoading,
    } = useFwWingstopR365TotalSalesPercentbyOrderMode()
    const {
      data: equivalentUnitCountData,
      loading: equivalentUnitCountLoading,
    } = useFarwestEquivalentUnitCount()

    const loading =
      salesbyOrderModeLoading ||
      salesbyDeliveryModeLoading ||
      salesPercentbyOrderModeLoading ||
      equivalentUnitCountLoading

    return useMemo(() => {
      const source = [
        ...(!kpiNames.some((n) => n === 'Average Weekly Sales by Order Mode')
          ? []
          : [
              { kpiName: 'Average Weekly Sales by Order Mode', ...titleData },
              ...(avgSalesbyOrderModeData?.map((d) => ({
                kpiName: d.avgOrderPriceName,
                farwestFlashSalesByOrderModeWeek1InPast:
                  ((d.avgOrderPriceWeek1InPast as number) / 100)?.toFixed(2) ||
                  '-',
                farwestFlashSalesByOrderModeWeek2InPast:
                  ((d.avgOrderPriceWeek2InPast as number) / 100)?.toFixed(2) ||
                  '-',
                farwestFlashSalesByOrderModeWeek3InPast:
                  ((d.avgOrderPriceWeek3InPast as number) / 100)?.toFixed(2) ||
                  '-',
                farwestFlashSalesByOrderModeWeek4InPast:
                  ((d.avgOrderPriceWeek4InPast as number) / 100)?.toFixed(2) ||
                  '-',
                farwestFlashSalesByOrderModeWeek5InPast:
                  ((d.avgOrderPriceWeek5InPast as number) / 100)?.toFixed(2) ||
                  '-',
                farwestFlashSalesByOrderModeWeek6InPast:
                  ((d.avgOrderPriceWeek6InPast as number) / 100)?.toFixed(2) ||
                  '-',
                farwestFlashSalesByOrderModeWeek7InPast:
                  ((d.avgOrderPriceWeek7InPast as number) / 100)?.toFixed(2) ||
                  '-',
                farwestFlashSalesByOrderModeWeek8InPast:
                  ((d.avgOrderPriceWeek8InPast as number) / 100)?.toFixed(2) ||
                  '-',
              })) || []),
              { kpiName: '', ...titleData },
            ]),

        { kpiName: 'Total Sales by Order Mode', ...titleData },
        ...(salesbyOrderModeData?.map((d) => ({
          kpiName: d.orderPriceName,
          farwestFlashSalesByOrderModeWeek1InPast:
            ((d.orderPriceWeek1InPast as number) / 100)?.toFixed(2) || '-',
          farwestFlashSalesByOrderModeWeek2InPast:
            ((d.orderPriceWeek2InPast as number) / 100)?.toFixed(2) || '-',
          farwestFlashSalesByOrderModeWeek3InPast:
            ((d.orderPriceWeek3InPast as number) / 100)?.toFixed(2) || '-',
          farwestFlashSalesByOrderModeWeek4InPast:
            ((d.orderPriceWeek4InPast as number) / 100)?.toFixed(2) || '-',
          farwestFlashSalesByOrderModeWeek5InPast:
            ((d.orderPriceWeek5InPast as number) / 100)?.toFixed(2) || '-',
          farwestFlashSalesByOrderModeWeek6InPast:
            ((d.orderPriceWeek6InPast as number) / 100)?.toFixed(2) || '-',
          farwestFlashSalesByOrderModeWeek7InPast:
            ((d.orderPriceWeek7InPast as number) / 100)?.toFixed(2) || '-',
          farwestFlashSalesByOrderModeWeek8InPast:
            ((d.orderPriceWeek8InPast as number) / 100)?.toFixed(2) || '-',
        })) || []),
        { kpiName: '', ...titleData },

        { kpiName: 'Total Sales Percent by Order Mode', ...titleData },
        ...(salesPercentbyOrderModeData?.map((d) => ({
          kpiName: d.orderPercentName,
          farwestFlashSalesByOrderModeWeek1InPast:
            (d.orderPercentWeek1InPast as number)?.toFixed(1) || '-',
          farwestFlashSalesByOrderModeWeek2InPast:
            (d.orderPercentWeek2InPast as number)?.toFixed(1) || '-',
          farwestFlashSalesByOrderModeWeek3InPast:
            (d.orderPercentWeek3InPast as number)?.toFixed(1) || '-',
          farwestFlashSalesByOrderModeWeek4InPast:
            (d.orderPercentWeek4InPast as number)?.toFixed(1) || '-',
          farwestFlashSalesByOrderModeWeek5InPast:
            (d.orderPercentWeek5InPast as number)?.toFixed(1) || '-',
          farwestFlashSalesByOrderModeWeek6InPast:
            (d.orderPercentWeek6InPast as number)?.toFixed(1) || '-',
          farwestFlashSalesByOrderModeWeek7InPast:
            (d.orderPercentWeek7InPast as number)?.toFixed(1) || '-',
          farwestFlashSalesByOrderModeWeek8InPast:
            (d.orderPercentWeek8InPast as number)?.toFixed(1) || '-',
        })) || []),
        { kpiName: '', ...titleData },

        { kpiName: 'Equivalent Unit Count', ...titleData },
        ...(equivalentUnitCountData?.source?.map((d) => ({
          kpiName: d.equivalentUnitCountName,
          farwestFlashSalesByOrderModeWeek1InPast:
            (d.equivalentUnitCountWeek1InPast as number)?.toFixed(2) || '-',
          farwestFlashSalesByOrderModeWeek2InPast:
            (d.equivalentUnitCountWeek2InPast as number)?.toFixed(2) || '-',
          farwestFlashSalesByOrderModeWeek3InPast:
            (d.equivalentUnitCountWeek3InPast as number)?.toFixed(2) || '-',
          farwestFlashSalesByOrderModeWeek4InPast:
            (d.equivalentUnitCountWeek4InPast as number)?.toFixed(2) || '-',
          farwestFlashSalesByOrderModeWeek5InPast:
            (d.equivalentUnitCountWeek5InPast as number)?.toFixed(2) || '-',
          farwestFlashSalesByOrderModeWeek6InPast:
            (d.equivalentUnitCountWeek6InPast as number)?.toFixed(2) || '-',
          farwestFlashSalesByOrderModeWeek7InPast:
            (d.equivalentUnitCountWeek7InPast as number)?.toFixed(2) || '-',
          farwestFlashSalesByOrderModeWeek8InPast:
            (d.equivalentUnitCountWeek8InPast as number)?.toFixed(2) || '-',
        })) || []),
      ]

      return {
        data: {
          source,
        },
        loading,
      }
    }, [
      loading,
      avgSalesbyOrderModeData,
      salesbyOrderModeData,
      salesPercentbyOrderModeData,
      equivalentUnitCountData,
    ])
  }

  return useFwWingstopR365SalesbyOrderMode
}

export const useFwWingstopR365SalesbyOrderMode =
  buildFwWingstopR365SalesByOrderMode([
    'Average Sales by Order Mode',
    'Total Sales by Order Mode',
    'Total Sales Percent by Order Mode',
    'Equivalent Unit Count',
  ])

export const useFwWingstopR365SalesbyOrderModeLocation =
  buildFwWingstopR365SalesByOrderMode([
    'Total Sales by Order Mode',
    'Total Sales Percent by Order Mode',
    'Equivalent Unit Count',
  ])
